import { useCallback, useState } from 'react'
import { Button } from 'blaze-ui/Button/Button'
import { REACT_APP_READER_URL } from 'env'
import { useQueryParams } from 'hooks/useQueryParams'
import { navigateToExternalUrl } from 'utils/location'
import Styles from './FacebookOAuthButton.module.scss'
import { IS_VM_REGISTRATION_KEY } from '../constants'
import { useIsOnboardingRedesign } from 'hooks/useIsOnboardingRedesign'
import { Facebook } from 'blaze-ui/icons'

const FacebookIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 26 26" fill="none">
      <path
        d="M11.5325 0.617839C13.8985 0.290207 16.3094 0.647398 18.4788 1.64714C20.6481 2.64693 22.4856 4.24775 23.7737 6.25944C25.0618 8.27113 25.7469 10.6099 25.7473 12.9987C25.7472 15.9757 24.6844 18.8551 22.7512 21.1188C20.818 23.3825 18.1405 24.8824 15.2004 25.3483V16.6139L18.1116 16.613H18.1126L18.6672 12.9987H15.2004V10.6549C15.2005 10.4076 15.2303 10.1618 15.3001 9.93229C15.3174 9.87521 15.3373 9.81916 15.3596 9.76432C15.4495 9.54376 15.5815 9.34347 15.7639 9.17741C15.9921 8.96989 16.2995 8.81648 16.7044 8.74577C16.7851 8.73166 16.8696 8.72084 16.9583 8.71354C17.0472 8.70622 17.1404 8.70182 17.2376 8.70182H18.8128V5.62467C18.8128 5.62467 17.7181 5.43795 16.5286 5.39128L16.0159 5.38151C15.9215 5.38151 15.8278 5.38262 15.7356 5.38639C13.2717 5.48711 11.6048 6.92938 11.3342 9.48796C11.3085 9.73065 11.2932 9.98319 11.2932 10.2458V12.9987H8.12037V16.6139H11.2932V25.3473C8.93419 24.974 6.73123 23.9336 4.94556 22.3473C3.15968 20.7608 1.86586 18.6953 1.21705 16.3962C0.568325 14.0972 0.591567 11.6607 1.28443 9.37467C1.97743 7.08854 3.31111 5.04852 5.1272 3.49674C6.94334 1.94496 9.16633 0.945548 11.5325 0.617839Z"
        fill="white"
      />
    </svg>
  )
}

export const FacebookOAuthButton = ({
  workspaceInviteToken,
  checkNewUser = false,
}: {
  workspaceInviteToken: string
  checkNewUser?: boolean
}) => {
  const isOnboardingRedesign = useIsOnboardingRedesign()
  const [isProcessing, setIsProcessing] = useState(false)
  const { domain, redirect_to, promotion_code, campaigns } = useQueryParams()

  const loginOrSignup = useCallback(async () => {
    localStorage.setItem(IS_VM_REGISTRATION_KEY, 'true')
    setIsProcessing(true)
    const state = {
      redirect_to,
      workspace_invite_token: workspaceInviteToken,
      domain,
      promotion_code,
      check_new_user: checkNewUser,
      campaigns,
    }

    const encodedState = btoa(JSON.stringify(state))
    const authUrl = `${REACT_APP_READER_URL}/omniauth/facebook?state=${encodedState}`

    if (window.top && window.top !== window) {
      window.top.location.href = authUrl
      return
    }

    navigateToExternalUrl(authUrl)
  }, [domain, redirect_to, workspaceInviteToken, promotion_code, checkNewUser, campaigns])

  if (isOnboardingRedesign) {
    return (
      <Button
        variant="secondary"
        size="xl"
        fullWidth
        frontIcon={Facebook}
        useChildClass
        onPress={loginOrSignup}
        isDisabled={isProcessing}
        data-heap-id="continue-with-facebook"
      >
        <div className={Styles.facebookButton}>Continue with Facebook</div>
      </Button>
    )
  }

  return (
    <div className={Styles.button}>
      <Button
        variant="tertiary"
        size="xl"
        fullWidth
        frontIcon={FacebookIcon}
        useChildClass
        onPress={loginOrSignup}
        isDisabled={isProcessing}
        data-heap-id="continue-with-facebook"
      >
        <div className={Styles.facebookOAuthButton}>Continue with Facebook</div>
      </Button>
    </div>
  )
}
